import React from 'react'
import {useParams} from "react-router";
import { useNavigate } from "react-router-dom";
import Countdown from "react-countdown";
import get from 'lodash/get'
import moment from 'moment'
import toast from 'react-hot-toast';
import useTransaction from "../../hooks/useTransaction";
import useCurrency from "../../utils/useCurrency";
import Loading from "../../component/loading";
import Page404 from "../404";
import qs from 'qs'
const TIMEOUT = 5000;
const STATUS = {
    SUCCESS: "SUCCESS",
    PROCESSING: "PROCESSING",
    FAILED: "FAILED",
    REFUNDED: "REFUNDED",
    REFUND_PROCESSING: "REFUND_PROCESSING",
};
const formatTime = (str) => String(str).padStart(2, "0");
const formatRemainingHours = (expiredTime) => {
    const now = moment();
    const end = moment(expiredTime);
    const totalSeconds = end.diff(now, 'seconds');
  
    const totalHours = Math.floor(totalSeconds / 3600);
    const remainingMinutes = Math.floor((totalSeconds % 3600) / 60);
    const remainingSeconds = totalSeconds % 60;
  
    const pad = (val) => String(val).padStart(2, '0');
  
    return `${totalHours}:${pad(remainingMinutes)}:${pad(remainingSeconds)}s`;
};
  
export default function Payment() {
    const refTimer = React.useRef(null);
    const navigate = useNavigate();
    const {code} = useParams();
    const {isLoading, data, isError, error, refetch} = useTransaction(code);
    const [expiredTime, setExpiredTime] = React.useState(0);
    const getField = (field) => get(data, field, "");
    const onBack = () => {
        const successUrl = getField('successRedirectUrl');
        if (successUrl) {
            defineUrl(successUrl)
            return
        }
        if (window.history.length > 1) {
            navigate(-1)
        } else {
            const confirm = window.confirm("Không có trang nào phía trước. Cửa sổ này sẽ được đóng nếu bạn đồng ý.");
            if (confirm) window.close()
        }
    }

    React.useEffect(() => {
        refetch()
    },[]);

    const defineUrl = (url) => {
        if (!url) return;
        const {search, pathname, origin} = new URL(url)
        let query = {
            bnplResponseCode: data.status,
            merchantRefId: data.merchantRefId,
            amount: data.amount,
            currency: data.currency
        };
        if (search) {
            let searchQs = qs.parse(search, { ignoreQueryPrefix: true });
            query = {...searchQs, ...query}
        }
        window.location.replace(`${origin}${pathname}?${qs.stringify(query)}`);
    }

    React.useEffect(() => {
        if (data) {
            const expired = getField('expiredIn');
            const successUrl = getField('successRedirectUrl');
            const failedUrl = getField('unSuccessRedirectUrl');
            clearInterval(refTimer.current);
            if (data.status === STATUS.PROCESSING) {
                refTimer.current = setInterval(refetch, process.env.TIMEOUT_RETRY || TIMEOUT)
            }
            if (data.status === STATUS.SUCCESS) {
                if (successUrl) {
                  defineUrl(successUrl)
                } else {
                  navigate('/404')
                }
                return
            }
            if (data.status === STATUS.FAILED) {
                if (failedUrl || successUrl) {
                  defineUrl(failedUrl || successUrl);
                } else {
                  navigate('/404')
                }
                return
            }
            if (expired) {
                setExpiredTime(moment(expired).valueOf())
            } else {
                const requestAt = moment(getField('requestAt')).add(30, "minutes");
                setExpiredTime(requestAt.valueOf())
            }
        }

        return () => {
            clearInterval(refTimer.current);
        }
    },[data])

    React.useEffect(() => {
        let message = 'Đã xảy ra lỗi không mong muốn. Chúng tôi đang cố gắng khắc phục.';
        if (error) toast.error(error.message ?? message);
    },[error]);

    const Finished = <div className="cf-bg-highlight expired">Giao dịch đã kết thúc</div>;
    const Deadline = React.useMemo(() => {
        if (expiredTime <= 0) return Finished;
        return (
            <Countdown date={expiredTime} renderer={({completed}) => {
                if (completed) return Finished;
                return (
                    <div className="cf-bg-highlight">Giao dịch kết thúc sau
                        <strong>{formatRemainingHours(expiredTime)}</strong>
                    </div>
                )
            }}/>
        )
    },[expiredTime]);
    if (isLoading) return <Loading/>;
    if (isError) return <Page404/>;
    return (
        <div className="cf-blk-content">
            <div className="bg-warning">
                <i className="icons icon-warning"/> Quý khách vui lòng không tắt trình duyệt cho đến khi hoàn thành giao dịch. Xin cảm ơn!
            </div>
            <div className="cf-row">
                <div className="cf-col-6 cf-content">
                    <button type="button" className="cf-btn-back cf-d-flex cf-none-mob" onClick={onBack}><i className="icons icon-back"/> Quay về</button>
                    <div className="cf-mb-5">
                        <h2 className="cfontsize-20 cf-none-mob">Thông tin đơn hàng</h2>
                        <p><span className="cf-gray">Mã đơn hàng:</span> <strong>{getField('merchantRefId')}</strong></p>
                        <p><span className="cf-gray cf-none-mob">Nhà cung cấp:</span> <strong className="cf-red">{getField('merchantName')}</strong></p>
                        <p><span className="cf-gray">Tổng tiền:</span> <strong>{useCurrency(getField('amount'))}</strong></p>
                        <p className="cf-none-mob"><span className="cf-gray">Mô tả:</span> <strong>{getField('notes')}</strong></p>
                    </div>
                    <div className="cf-mb-5 cf-none-mob">
                        <h4 className="cfontsize-20">Hướng dẫn thanh toán</h4>
                        <ul className="cf-unorderlist cfontsize-15">
                            <li><span className="cf-gray">Bước 1:&nbsp;</span>Mở ứng dụng&nbsp;<strong>BNPL</strong>&nbsp;trên điện
                                thoại.
                            </li>
                            <li><span className="cf-gray">Bước 2:&nbsp;</span>Chọn biểu tượng <img
                                src="/assets/images/icon-qr.png" width="29" alt=""/> để&nbsp;<strong>Quét mã</strong>.</li>
                            <li><span className="cf-gray">Bước 3:&nbsp;</span>Quét mã QR ở trang này và thanh toán</li>
                        </ul>
                        {Deadline}
                    </div>
                </div>
                <div className="cf-col-6">
                    <div className="cf-visual flex-center cf-h-100">
                        <p><strong>Thanh toán bằng ứng dụng BNPL</strong></p>
                        <div className="cf-bg-light cf-qr-code">
                            <img src={"data:image/png;base64,"+getField('qrCodeData')} alt=""/>
                        </div>
                        <p>Quét mã QR để thanh toán</p>
                    </div>
                </div>
            </div>
        </div>
    )
}